import * as yup from 'yup';

yup.setLocale({
  mixed: {
    default: ({ path }) => `Please input a valid ${path}.`,
    required: 'This field is required',
  },
  string: {
    email: 'Please input a valid email address',
    max: ({ max }) =>
      `The text entered exceeds the maximum length of ${max} characters`,
  },
});

export default yup;